const options = {
  5: "bg-teal-900/5",
  10: "bg-teal-900/10",
  25: "bg-teal-900/25",
  50: "bg-teal-900/50",
  75: "bg-teal-900/75",
  90: "bg-teal-900/90",
  100: "bg-teal-900",
};

const from = {
  5: "from-teal-900/5",
  10: "from-teal-900/10",
  25: "from-teal-900/25",
  50: "from-teal-900/50",
  75: "from-teal-900/75",
  90: "from-teal-900/90",
  100: "from-teal-900",
};

export default function getBackgroundTeal900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
